<template>
  <div class="s-wizard__questions__body">
    <div class="question-row--two-column">
      <span class="question-text">
        {{ stepData[0].questionTxt }}
      </span>

      <div class="question-options--grid">
        <div
          v-for="(step, index) in formatedData"
          :key="index"
          class="option"
          :class="{ selected: selectedOption === step.id }">
          <template v-if="stepData[0].type === 'single'">
            <input
              :id="step.id"
              v-model="selectedOption"
              type="radio"
              name="option"
              :value="step.id"
              @change="selectAnswer(stepData[0].type)" />
          </template>

          <template v-if="stepData[0].type === 'multiple'">
            <input
              :id="step.id"
              v-model="selectedOption"
              type="checkbox"
              name="option"
              :value="step.id"
              @change="selectAnswer(stepData[0].type)" />
          </template>

          <label :for="step.id" v-html="step.text"></label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from '../../../lib/lib'

export default {
  props: {
    stepData: {
      required: true,
      type: Array,
    },
    currentStep: {
      required: true,
      type: Number,
    },
  },
  emits: ['enable-next-btn', 'gather-data'],
  data() {
    return {
      selectedOption: [],
    }
  },

  computed: {
    formatedData() {
      return this.stepData[0].answers
    },
  },
  mounted() {
    const { steps } = lib.getData('wizardDataNew')
    this.steps = steps
  },

  methods: {
    selectAnswer(type) {
      if (type === 'single') {
        if (this.selectedOption.length) {
          this.$emit('enable-next-btn', true)
          this.$emit('gather-data', {
            questionId: this.stepData[0].id,
            answerIds: [this.selectedOption],
          })
        }
      }

      if (type === 'multiple') {
        if (this.selectedOption.length) {
          this.$emit('enable-next-btn', true)
          this.$emit('gather-data', {
            questionId: this.stepData[0].id,
            answerIds: this.selectedOption,
          })
        }
      }
    },
  },
}
</script>
